var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "el-table-emptyImg" }, [
    _c("img", { staticClass: "empty", attrs: { src: _vm.src, alt: "" } }),
    _c("span", { staticClass: "no-data" }, [_vm._v("暂无数据")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }